import { requestMain } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const defaultCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
export const apiPostRedEnvelope = () =>
  requestMain("put", `/${defaultCurrency}/promotion/register/bonus/apply`, null, true, false);

export const apiGetRedEnvelopeEligibility = () =>
  requestMain("get", `/${defaultCurrency}/promotion/register/bonus/check`, null, true, false);
